import FluidMonitor from './FluidMonitor'

export default FluidMonitor
